import React from "react";
import { Col, ControlLabel, FormControl, FormGroup, HelpBlock } from "react-bootstrap";

export default function FormControlInlineSelect({ controlId, validationState, label, value, onChange,
  options, helpText, className, withEmptyOption, disabled }) {

  return (
    <FormGroup controlId={ controlId } validationState={ validationState }>

      <Col componentClass={ ControlLabel } sm={4}>
        { label }
      </Col>
      <Col sm={8}>
        <FormControl id={ controlId } componentClass="select" placeholder="Select"
          value={ value } className={ className } disabled={ disabled }
          onChange={e => onChange(e.target.value)}>

          { withEmptyOption && <option value='' title=''></option>}

          { options.map((option, index) =>
            <option key={ index } value={ option.value } title={ option.title }>{ option.title }</option>)}
        </FormControl>
        <FormControl.Feedback />
        <HelpBlock>{ helpText }</HelpBlock>
      </Col>
    </FormGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/fragments/FormControl.Inline.Select.js